import React from 'react'

export default class IconsDnDCaptcha extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M13.3333 8.66664C13.3333 12 11 13.6666 8.22666 14.6333C8.08143 14.6825 7.92368 14.6802 7.77999 14.6266C4.99999 13.6666 2.66666 12 2.66666 8.66664V3.99997C2.66666 3.82316 2.73689 3.65359 2.86192 3.52857C2.98694 3.40355 3.15651 3.33331 3.33332 3.33331C4.66666 3.33331 6.33332 2.53331 7.49332 1.51997C7.63456 1.39931 7.81423 1.33301 7.99999 1.33301C8.18575 1.33301 8.36542 1.39931 8.50666 1.51997C9.67332 2.53997 11.3333 3.33331 12.6667 3.33331C12.8435 3.33331 13.013 3.40355 13.1381 3.52857C13.2631 3.65359 13.3333 3.82316 13.3333 3.99997V8.66664Z'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6 8.00008L7.33333 9.33341L10 6.66675'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
